import 'select2';
import Select2Component from "./select2";
new Select2Component();